import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { FontIcon } from "component/w24/component/FontIcon"
import { motion } from "framer-motion"
import { AnimTap, EColors, EFonts, EVariables } from "libs/style/w24_styling"
import React from "react"
import styled, { css } from "styled-components/macro"

interface Props {
  icon: IconDefinition
  title: string
  onClick?: () => void
  selected?: boolean
  className?: string
}

export const MenuItem = (props: Props): JSX.Element => {
  return (
    <S_MenuItem
      className={props.className}
      onClick={props.onClick}
      $selected={props.selected}
      {...AnimTap}
    >
      <S_FontIcon icon={props.icon} color={EColors.DARK} iconSize="16px" />
      <S_Title $selected={props.selected}>{props.title}</S_Title>
    </S_MenuItem>
  )
}

const S_MenuItem = styled(motion.div)<{ $selected: boolean }>`
  display: inline-flex;
  padding: 13px 21px;
  align-items: center;
  gap: 17px;
  border-radius: ${EVariables.Radius1};
  width: fit-content;
  cursor: pointer;
  user-select: none;
  ${props => {
    if (props.$selected) {
      return css`
        background-color: ${EColors.GREY2};
      `
    } else {
      return css`
        &:hover {
          background-color: ${EColors.DARK};
          ${S_Title} {
            color: ${EColors.WHITE};
          }
          svg {
            color: white;
          }
        }
      `
    }
  }}
`

const S_FontIcon = styled(FontIcon)`
  color: red;
`

const S_Title = styled.div<{ $selected: boolean }>`
  color: ${EColors.DARK};
  font-family: ${EFonts.Bold};
  font-size: 16px;
  ${props => {
    if (props.$selected) {
      return css`
        color: ${EColors.DARK};
      `
    }
  }}
`
